// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Rana backend API
 * The API service for Rana.
 *
 * The version of the OpenAPI document: v1-alpha
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { parseDate, parseDateTime, serializeDate, serializeDateTime } from "../runtime";
import type { FolderOutput } from "./FolderOutput";
import {
  instanceOfFolderOutput,
  FolderOutputFromJSON,
  FolderOutputFromJSONTyped,
  FolderOutputToJSON,
} from "./FolderOutput";
import type { LayerOutput } from "./LayerOutput";
import {
  instanceOfLayerOutput,
  LayerOutputFromJSON,
  LayerOutputFromJSONTyped,
  LayerOutputToJSON,
} from "./LayerOutput";

/**
 * @type LayersInner1
 *
 * @export
 */
export type LayersInner1 = ({ type: "folder" } & FolderOutput) | ({ type: "layer" } & LayerOutput);

export function LayersInner1FromJSON(json: any): LayersInner1 {
  return LayersInner1FromJSONTyped(json, false);
}

export function LayersInner1FromJSONTyped(json: any, ignoreDiscriminator: boolean): LayersInner1 {
  if (json == null) {
    return json;
  }
  switch (json["type"]) {
    case "folder":
      return Object.assign({}, FolderOutputFromJSONTyped(json, true), { type: "folder" } as const);
    case "layer":
      return Object.assign({}, LayerOutputFromJSONTyped(json, true), { type: "layer" } as const);
    default:
      return json;
  }
}

export function LayersInner1ToJSON(json: any): any {
  return LayersInner1ToJSONTyped(json, false);
}

export function LayersInner1ToJSONTyped(
  value?: LayersInner1 | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }
  switch (value["type"]) {
    case "folder":
      return Object.assign({}, FolderOutputToJSON(value), { type: "folder" } as const);
    case "layer":
      return Object.assign({}, LayerOutputToJSON(value), { type: "layer" } as const);
    default:
      return value;
  }
}
